import React from 'react'
import "./styles/App.css"
import Nav from './Nav/Nav'
import Body from './Body/Body'


function App() {


  return (<>
     <Nav></Nav>
     <Body></Body>
  </>
  )
}

export default App